<template>
  <b-row>
    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        @row-clicked="clickVoucher"
      >
        <template #cell(Drivers)="data">
          <b-badge style="color: #e8e8e8; background: #2d839e">
            {{ DriverList[0].Name }}
          </b-badge>
        </template>
      </b-table>
    </b-col>

    <b-col
      cols="12"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-0"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  data() {
    return {
      perPage: 1000,
      pageOptions: [10, 25, 60, 1000],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'day', label: 'day',
        },
        {
          key: 'hours', label: 'Stunden',
        },
      ],
      items: [],
      DriverList: [{
        Name: 'REM',
        Label: 'light-success',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    this.LoadList()
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    clickVoucher(record, index) {
      this.$router.push({ name: 'VoucherMask', params: { id: record.Vid } })
    },
    LoadList() {
      this.$http.get('http://localhost:4477/getProjects')
        .then(resp => {
          let hours = 0
          resp.data.forEach(i => {
            if (i.Name == 'Ftpro') {
              console.log(i)
              Object.keys(i.Hours).forEach(key => {
                const d = `${(i.Hours[key] / 60).toFixed(2)} (${i.Hours[key]}})`
                hours += i.Hours[key]
                this.items.push({ day: key, hours: d })
              })
            }
          })

          const d = `${(hours / 60).toFixed(2)} (${hours}})`
          this.items.push({ day: "Gesamt", hours: d})
        })
        .catch(err => {
          console.error(err)
        })
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
